import { Trans } from '@lingui/react'

import IconSmartphone from 'views/components/atoms/Icon/IconSmartphone'
import TextWithIcon from 'views/components/molecules/TextWithIcon'
import TransWithHtml from 'views/components/utils/TransWithHtml'

const ProductConsultationDirect = () => (
  <>
    <p>
      <Trans id="product.consultation.direct.headline" />
    </p>
    <TextWithIcon
      icon={<IconSmartphone size="large" className="u-color--blue" />}
    >
      <h4 className="a-h2 u-no-margin">
        <TransWithHtml id="product.consultation.direct.contact" />
      </h4>
    </TextWithIcon>
  </>
)

export default ProductConsultationDirect
